require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/Core/Core/web/reviewportal/node_modules/raw-loader/index.js!/home/runner/work/Core/Core/web/reviewportal/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/dist/js/bootstrap.min.js
// module id = 583
// module chunks = 2